module.exports = __webpack_public_path__ + "img/icon_payment_visa.ff060103.svg";